import { createRouter, createWebHistory } from 'vue-router'


import Login from "@/pages/admin/AdminLogin.vue";
import AdminDashboard from "@/pages/admin/AdminDashboard.vue";
import Admin from "@/pages/admin/AdminPage.vue";
import AdminForm from "@/pages/admin/AdminForm.vue";


import Student from "@/pages/admin/StudentPage.vue";
import StudentForm from "@/pages/admin/StudentForm.vue";
import Categories from "@/pages/admin/categoryPage.vue";
import PaymentMethods from "@/pages/admin/PaymentMethodPage.vue";
import PaymentMethodForm from "@/pages/admin/PaymentMethodForm.vue";
import ShippingMethods from "@/pages/admin/ShippingMethodPage.vue";
import ShippingMethodForm from "@/pages/admin/ShippingMethodForm.vue";

import Address from "@/pages/admin/AddressPage.vue";
import AddressForm from "@/pages/admin/AddressForm.vue";

import Products from "@/pages/admin/ProductPage.vue";
import ProductForm from "@/pages/admin/ProductForm.vue";
import Chapters from "@/pages/admin/ProductChaptersPage.vue";

import Orders from "@/pages/admin/OrderPage.vue";
import OrderForm from "@/pages/admin/OrderForm.vue";


import Invoices from "@/pages/admin/invoicePage.vue";
import InvoicePrint from "@/pages/admin/InvoicePrint.vue";




import TestApi from "@/pages/admin/TestApi.vue";

import auth from "@/middleware/auth.js";



const routes = [
  {
    path: "/", name: "Login", component: Login,
    meta: {
      middleware: [auth],
    },

  },

  {
    path: "/admin-dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/admin-create",
    name: "AdminCreate",
    component: AdminForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/admin/:id/edit",
    name: "AdminUpdate",
    component: AdminForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/students",
    name: "Student",
    component: Student,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/Student-create",
    name: "StudentCreate",
    component: StudentForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/student/:id/edit",
    name: "StudentUpdate",
    component: StudentForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/categories",
    name: "Categories",
    component: Categories,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/payment-methods",
    name: "PaymentMethods",
    component: PaymentMethods,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/payment-method-create",
    name: "PaymentMethodCreate",
    component: PaymentMethodForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/payment-method/:id/edit",
    name: "PaymentMethodUpdate",
    component: PaymentMethodForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/shipping-methods",
    name: "ShippingMethods",
    component: ShippingMethods,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/shipping-method-create",
    name: "ShippingMethodCreate",
    component: ShippingMethodForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/shipping-method/:id/edit",
    name: "ShippingMethodUpdate",
    component: ShippingMethodForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


  {
    path: "/address",
    name: "Address",
    component: Address,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/address-create/:user_id",
    name: "AddressCreate",
    component: AddressForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/address/:id/edit",
    name: "AddressUpdate",
    component: AddressForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/product-create",
    name: "Product",
    component: ProductForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  {
    path: "/product/:id/edit",
    name: "ProductUpdate",
    component: ProductForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/product/:id/chapter",
    name: "Chapter",
    component: Chapters,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },

  {
    path: "/orders",
    name: "Orders",
    component: Orders,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


  {
    path: "/order/:id/edit",
    name: "OrderUpdate",
    component: OrderForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


  {
    path: "/order-create",
    name: "OrderCreate",
    component: OrderForm,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


  {
    path: "/invoices",
    name: "Invoices",
    component: Invoices,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },


    {
      path: "/invoice/:id/print",
      name: "InvoicePrint",
      component: InvoicePrint,
      meta: {
        requiresAuth: true,
        middleware: [auth],
      },
    },







  {
    path: "/test-api",
    name: "TestApi",
    component: TestApi,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
  },
  //   {
  //     path: '/users',
  //     name: 'Users',
  //     component: () => import('@/views/UsersView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   },
  //   {
  //     path: '/sites',
  //     name: 'Sites',
  //     component: () => import('@/views/SitesView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   },
  //   {
  //     path: '/reports',
  //     name: 'Reports',
  //     component: () => import('@/views/ReportsView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   },
  //   {
  //     path: '/analyze-Detail/:id',
  //     name: 'AnalyzeDetail',
  //     component: () => import('@/views/AnalyzeDetailView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   }
  //   ,
  //   {
  //     path: '/page-detail/:id',
  //     name: 'PageDetail',
  //     component: () => import('@/views/PageDetailView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   }


  //    ,
  //   {
  //     path: '/detail/:id',
  //     name: 'Detail',
  //     component: () => import('@/views/DetailView.vue'),
  //     meta: {
  //       requiresAuth: true,
  //       middleware: [auth],
  //     },
  //   }

];



const router = createRouter({
  history: createWebHistory(),
  routes
})



// 🧠 اجرای میدلورها قبل از هر روت
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  const middlewares = to.meta.middleware;

  const context = { to, from, next, router };

  const runMiddlewares = (index) => {
    const middleware = middlewares[index];
    if (!middleware) return next();
    console.log(`[ROUTER] running middleware ${index} for ${to.path}`);

    middleware({
      ...context,
      next: (...params) => runMiddlewares(index + 1, ...params),
    });
  };

  runMiddlewares(0);
});

export default router


